@if (reload) {
<div class="icon-nav -container">
  <div class="d-flex -menu-icons">
    <div class="icon-nav -container -item -solution-finder">
      <wpbutton to="/solution-finder" class="-secondary">Solution Finder</wpbutton>
    </div>
    <div class="icon-nav -container -item -announcement" [ngClass]="showLogin ? '-not-logged-in' : ''">
      <a class="-announcement-link">
          <icon icon="bell" class="-announcement-icon"></icon>
      </a>
    </div>
    @if (theme) {
    <div class="icon-nav -container -item -theme-icon">
      <a (click)="switchThemeMode()">
        @if ((theme == 'light')) {
          <icon icon="moon" class="-theme -moon-dark"></icon>  
        }
        @if ((theme == 'dark')) {
          <icon icon="sun" class="-theme -sun-light"></icon>
        }
      </a>
    </div>
    }
    <div class="icon-nav -container -item -search-box">
      <a class="">
        <app-search-box></app-search-box>
      </a>
    </div>
    @for (icon of menuIcons; track icon) {
    <div class="icon-nav -container -item" [ngClass]="icon.icon === 'person' ? '-user-account' : '-user-help'">
      @if (icon.externalPath) {
      <a [href]="icon.externalPath" class="icon-nav -item" aria-label="ExternalNav">
        <button-icon [icon]="icon.icon" iconhovercolor="-colorAccentLightBlue" iconcolor="-colorSupportingWhite">
        </button-icon>
      </a>
      } @else {
      <div
        class="icon-nav -navIcon"
        [ngClass]="icon.icon === 'person' || icon.icon === 'help' ? 'no-close' : ''"
        (click)="(icon.icon === 'person' || icon.icon === 'help') && toggleMenu(icon.icon)">
        @if (icon.icon === 'person') {
        <span>
          <span class="icon-nav -item" aria-label="InternalNav">
            <button-icon
              [icon]="icon.icon"
              class="{{ profileIcon }}"
              iconhovercolor="-colorAccentLightBlue"
              [iconcolor]="router.url.includes(icon.path) ? '-colorAccentLightBlue' : '-colorSupportingWhite'">
            </button-icon>
          </span>
        </span>
        } @if (icon.icon === 'help') {
        <span>
          <button-icon [icon]="icon.icon"></button-icon>
        </span>
        } @if (icon.icon == 'person') {
        <account-dropdown [headerText]="fullName" class="no-close icon-nav {{ mobileDropdown }}"></account-dropdown>
        } @if (icon.icon == 'help') {
        <account-dropdown [dropdownTo]="icon.children" class="no-close icon-nav {{ helpDropDown }}"></account-dropdown>
        }
      </div>
      }
    </div>
    }
  </div>
  @if (showLogin) {
    <a [routerLink]="'/dashboard/login'"
    class="icon-nav -container -item -loginLink">Login</a>
  }
</div>
}